
import { IrisBase } from '@/models/iris/IrisBase'
import { IAd2cpEnable, getDefaultAd2cpEnable } from './IAd2cpEnable'
import { IAd2cpQc, getDefaultAd2cpQc } from './IAd2cpQc'
import { IAd2cpSensor, getDefaultAd2cpSensor } from './IAd2cpSensor'
import { IAd2cpState, getDefaultAd2cpState } from './IAd2cpState'

export interface IAd2cpConfig extends IrisBase {
    AD2CP_QC:IAd2cpQc
    AD2CP_Sensor:IAd2cpSensor
    AD2CP_state:IAd2cpState
    EnabledMOD:IAd2cpEnable        
} 

export const getDefaultAd2cpConfig = ():IAd2cpConfig => {
    return {
        AD2CP_QC:getDefaultAd2cpQc(),
        AD2CP_Sensor:getDefaultAd2cpSensor(),
        AD2CP_state:getDefaultAd2cpState(),
        EnabledMOD:getDefaultAd2cpEnable()
    }
}